import { UserProfileActions } from '../types/UserProfileAction';
import UserProfileBody, { defaultUserProfileBody } from '../types/UserProfileBody';
import UserActivityLog from '../types/UserActivityLog';

interface InitialState {
  profile: UserProfileBody | {},
  activity: UserActivityLog[],
}

const initialState: InitialState = {
  profile: {},
  activity: []
}

const userProfileReducers = (state = initialState, action: UserProfileActions) => {
  switch (action.type) {
    case 'USER_PROFILE_SUCCESS': {
      
      return { ...state, profile: action.data };
    }
    case 'USER_ACTIVITY_LIST_SUCCES': {
      let {activity} = state;
      let data = action.data ? action.data : [];
      let newActivity = [...activity, ...data]
      return { ...state, activity: newActivity };
    }
    default: {
      return state;
    }
  }
}

export default userProfileReducers;